import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'

import { AlertNotice } from '@ui/components/AlertNotice'
import { WarningIcon } from '@ui/icons/Warning.icon'

import { isImpersonatedSession } from '@model/User'

export const ImpersonationBanner: React.FC = () => {
  const [auth] = useContext(AuthSessionContext)
  const { t } = useTranslation()

  if (!isImpersonatedSession(auth)) return null

  return (
    <AlertNotice
      id='impersonation-banner'
      title={t('Impersonation.Title')}
      message={t('Impersonation.Banner')}
      type='danger'
      icon={{ icon: WarningIcon, color: 'text-danger-med-em' }}
    />
  )
}
